import { render, staticRenderFns } from "./OrcidLink.vue?vue&type=template&id=43b9fe3d&scoped=true"
import script from "./OrcidLink.vue?vue&type=script&lang=js"
export * from "./OrcidLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b9fe3d",
  null
  
)

export default component.exports